import { getTestIds } from 'seagull/utils/TestIds';
export const GetHelpMeWriteOutputRendererTID = (parentTestId)=>getTestIds(parentTestId);
